import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { RichLine } from "./Reveal";

export const Showcase = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const scale = useTransform(scrollYProgress, [0, 0.7], [0.32, 1]);
  const radius = useTransform(scrollYProgress, [0, 0.7], [36, 0]);
  const backOp = useTransform(scrollYProgress, [0, 0.45], [1, 0]);
  const textOp = useTransform(scrollYProgress, [0.68, 0.88], [0, 1]);
  const textY = useTransform(scrollYProgress, [0.68, 0.88], [40, 0]);

  return (
    <section data-testid="showcase-section" ref={ref} className="relative h-[260vh]">
      <div className="sticky top-0 h-screen overflow-hidden flex items-center justify-center bg-[#faf9f6]">
        <motion.div
          style={{ opacity: backOp }}
          className="absolute inset-0 flex flex-col justify-between items-center py-[10vh] select-none pointer-events-none"
          aria-hidden="true"
        >
          <span className="font-display italic text-[15vw] leading-none text-gradient-fire">{t.showcase.back1}</span>
          <span className="font-display italic text-[15vw] leading-none text-gradient-fire">{t.showcase.back2}</span>
        </motion.div>

        <motion.div style={{ scale, borderRadius: radius }} className="relative w-full h-full overflow-hidden">
          <video
            data-testid="showcase-video"
            poster="/videos/masonry.jpg"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="w-full h-full object-cover"
          >
            <source src="/videos/masonry.mp4" type="video/mp4" />
            <source src="/videos/masonry.webm" type="video/webm" />
          </video>
          <div className="absolute inset-0 bg-black/35" />
          <motion.div
            style={{ opacity: textOp, y: textY }}
            className="absolute inset-0 flex flex-col items-center justify-center text-center px-6"
          >
            <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl text-white leading-[1.08] max-w-4xl">
              <RichLine segments={t.showcase.title} />
            </h2>
            <p className="mt-6 font-tech text-[11px] tracking-[0.35em] uppercase text-white/60">{t.showcase.caption}</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
